import { FormGroup, FormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { CtwrPartService } from '../../ctwr.service';

export class PartsGrid extends DataGridTemplate {

    editForm: FormGroup;
    filter: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selectedPart: any;
    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly partService: CtwrPartService
    ) {
        super();
        this.controls.edit = false;
        this.controls.add = false;
        this.controls.excel = false;
        this.controls.delete = false;
        this.selectableSettings.enabled = true;
        this.selectableSettings.mode = 'single';
        this.selectableSettings.checkboxOnly = false;
        this.gridState.take = 5;
        this.filter.subscribe(x => this.refresh());
        this.select = this.handleSelect;
        this.saveUserSettings = false;
    }


    read(parentEditDataItem: any): Promise<any> {
        return this.filter.value ?
            this.partService.search(this.filter.value, '/search')
                .then(x => x.PartsDetail) :
            Promise.resolve([]);
    }


    create(parentEditDataItem: any): void {
    }


    edit(dataItem: any): void {
    }


    save(dataItem: any, isNew: boolean): Promise<any> {
        return null;
    }


    delete(dataItem: any): Promise<any> {
        return null;
    }


    handleSelect = (data: any[]) => {
        this.selectedPart = data[0] ? data[0].dataItem : null;
    }

    columns: any[] = [
        {
            field: 'PartNumber',
            title: 'Part Number'
        },
        {
            field: 'ProcessName',
            title: 'Process',
        },
        {
            field: 'DesignPhase',
            title: 'Design Phase',
        },
        {
            field: 'Location',
            title: 'Location',
        },
        {
            field: 'PartType',
            title: 'Type',
        },
        {
            field: 'ProgramName',
            title: 'Program',
        },

    ]

}

